import Immutable from "immutable";
import SearchFilterTransformationWarning from "search-filter/components/SearchFilterTransformationWarning";
import SearchPageSearchFilterBar from "search-filter/components/SearchPageSearchFilterBar";
import validLicensePresent from "license/ValidLicensePresent";
import generateId from "logic/generateId";
import MyFiltersDetailsPage from "search-filter/pages/MyFiltersDetailsPage";
import MyFiltersEditPage from "search-filter/pages/MyFiltersEditPage";
import MyFiltersCreatePage from "search-filter/pages/MyFiltersCreatePage";
import MyFiltersOverviewPage from "search-filter/pages/MyFiltersOverviewPage";
import getInaccessibleFiltersFromView from "search-filter/logic/getInaccessableFiltersFromView";
import transformInaccessibleFiltersInSearch from "search-filter/logic/transformInaccessibleFiltersInSearch";
import transformInaccessibleFiltersInDashboard from "search-filter/logic/transformInaccessibleFiltersInDashboard";
import CreateSearchFilterFromCurrentQuery from "search-filter/CreateSearchFilterFromCurrentQuery";
import SearchFilterActionsProvider from "search-filter/SearchFilterActionsProvider";
import SearchFilterBar from "search-filter/components/search-filter-bar/SearchFilterBar";
import { prefixUrl } from "routing/Routes";
import SearchFiltersRoutes from "./Routes";
const initSearchFilterBarValues = (entity) => {
  var _a;
  if (!entity) {
    return void 0;
  }
  const searchFilters = (_a = entity.filters) != null ? _a : Immutable.List();
  return {
    searchFilters: Immutable.OrderedMap(
      searchFilters.map((filter) => {
        var _a2;
        const frontendId = (_a2 = filter.id) != null ? _a2 : generateId();
        return [frontendId, { ...filter, frontendId }];
      })
    )
  };
};
const onSubmitSearchBar = ({ searchFilters }, _dispatch, currentEntity) => {
  var _a;
  if (!currentEntity) {
    return Promise.resolve();
  }
  const filters = (_a = searchFilters.map(({ frontendId, ...rest }) => rest)) != null ? _a : Immutable.OrderedMap();
  return Promise.resolve(currentEntity.toBuilder().filters(filters.toList()).build());
};
const searchBarPlugin = {
  useInitialSearchValues: initSearchFilterBarValues,
  useInitialDashboardWidgetValues: initSearchFilterBarValues,
  onSearchSubmit: onSubmitSearchBar,
  onDashboardWidgetSubmit: onSubmitSearchBar,
  id: "search-filters",
  placement: "left"
};
const bindings = {
  routes: [
    { path: SearchFiltersRoutes.unqualified.LIST, component: MyFiltersOverviewPage },
    { path: SearchFiltersRoutes.unqualified.NEW, component: MyFiltersCreatePage },
    { path: SearchFiltersRoutes.unqualified.EDIT(":filterId"), component: MyFiltersEditPage },
    { path: SearchFiltersRoutes.unqualified.SHOW(":filterId"), component: MyFiltersDetailsPage }
  ],
  "views.components.searchBar": [
    () => validLicensePresent() ? {
      ...searchBarPlugin,
      component: SearchPageSearchFilterBar
    } : null
  ],
  "eventDefinitions.components.searchForm": [
    () => validLicensePresent() ? {
      ...searchBarPlugin,
      component: SearchFilterBar
    } : null
  ],
  "views.components.saveViewForm": [
    () => validLicensePresent() ? {
      id: "search-filter-transformation",
      component: SearchFilterTransformationWarning,
      onSearchDuplication: async (view, userPermissions) => {
        var _a;
        const hasInaccessibleSearchFilters = !!((_a = getInaccessibleFiltersFromView(view, userPermissions)) == null ? void 0 : _a.size);
        if (hasInaccessibleSearchFilters) {
          return Promise.resolve(transformInaccessibleFiltersInSearch(view, userPermissions));
        }
        return Promise.resolve(view);
      },
      onDashboardDuplication: async (view, userPermissions) => {
        var _a;
        const hasInaccessibleSearchFilters = !!((_a = getInaccessibleFiltersFromView(view, userPermissions)) == null ? void 0 : _a.size);
        if (hasInaccessibleSearchFilters) {
          return Promise.resolve(transformInaccessibleFiltersInDashboard(view, userPermissions));
        }
        return Promise.resolve(view);
      }
    } : null
  ],
  "views.queryInput.commands": [
    {
      name: "create-search-filter",
      bindKey: {
        mac: "Alt+Enter",
        win: "Alt+Enter"
      },
      usages: ["search_query", "widget_query"],
      exec: CreateSearchFilterFromCurrentQuery
    }
  ],
  "views.queryInput.commandContextProviders": [SearchFilterActionsProvider],
  entityTypeRoute: [
    {
      type: "search_filter",
      route: (id) => prefixUrl(`/my-filters/details/${id}`)
    }
  ]
};
export default bindings;
